import React from 'react';
import {UpperBar, LinkBar, Container} from './styles'
import {Link} from 'react-router-dom'

function Header() {
  return (
    <Container>
      <UpperBar>
        <LinkBar><Link to="/">Home</Link></LinkBar>
        <LinkBar><Link to="/aboutme">Sobre Mim</Link></LinkBar>
        <LinkBar><Link to="/projects">Projetos</Link></LinkBar>
        <LinkBar><Link to="/contact">Contato</Link></LinkBar>
      </UpperBar>
    </Container>
  );
}

export default Header;